import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Button,
} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { BsCloudDownload, BsPaperclip, BsCheck } from "react-icons/bs";
import { MdAdd, MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

//Componentes
import Loading from "../../components/modales/loadingModal";
import Loader from "react-loaders";
// import Button from '@material-ui/core/Button';
import HorizontalLabelPositionBelowStepper from "../../components/stepper/stepper";
import InfoCard from "../../components/cards/cardInfoSeccion";
import ModalCancelacion from "./componentes/modalCancelacion";
import ModalAdjunto from "./componentes/modalAdjunto";
import ModalSuspenderAPE from "./componentes/modalSuspenderAPE";
import ModalRevision from "./componentes/modalRevision";
import ModalPruebasTecnicas from "./componentes/modalPruebasTecnicas";
import ModalEntrevista from "./componentes/modalEntrevista";
import ModalEstudioSeguridad from "./componentes/modalEstudioSeguridad";
import ModalExamenes from "./componentes/modalExamenes";
import ModalProcesoAprobado from "./componentes/modalProcesoAprobado";
import ModalPublicacion from "./componentes/modalPublicacion";
import ModalRevisionOperaciones from "./componentes/modalRevisionOperaciones";
import ModalListaChequeo from "./componentes/modalListaChequeo";
import DescargarAPEButton from "../../components/buttons/DescargarAPEButton";
import DescargarZIPButton from "../../components/buttons/DescargarZIPButton";
import OnHoldAPEButton from "../../components/buttons/OnHoldAPEButton";

//Funciones
// import { getItemsList, deleteFile } from '../../utils/azureStorage/upload';

import {
  getFileList,
  getDownloadURLAPI,
  deleteFile,
  getFinalFileZip,
} from "../../utils/FirebaseStorage/FirebaseStorage";

//Utils
import { glosarioProceso1 } from "./utils/glosarioSolicitudes";
import LoadingModalTransparent from "../../components/modales/loadingModalTransparent";

//API Calls
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

const getAPE = functionsHttpsCallable("ape_getSolicitudPorId");
const editarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");
const editarCandidato = functionsHttpsCallable("ape_editarCandidato");
const envioCorreoDevolucion = functionsHttpsCallable(
  "correos_envioCorreoDevolucion"
);
const exportarAPE = functionsHttpsCallable("ape_exportarSolicitud");
const listadoCandidatos = functionsHttpsCallable("ape_listadoCandidatos");

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

let VisualizadorAPEReclutamiento = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [candidatos, setCandidatos] = useState([]);
  const [dataCandidatoActivo, setDataCandidatoActivo] = useState([]);
  const [editAttachments, setEditAttachments] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [pasoActivo, setPasoActivo] = useState(0);
  const [pasos, setPasos] = useState([]);
  const [selectState, setSelectState] = useState(false);
  const [stateModalAdjunto, setStateModalAdjunto] = useState(false);
  const [stateModalCancelacion, setStateModalCancelacion] = useState(false);
  const [stateModalSuspender, setStateModalSuspender] = useState(false);
  const [stateModalEntrevista, setStateModalEntrevista] = useState(false);
  const [stateModalEstudio, setStateModalEstudio] = useState(false);
  const [stateModalExamenes, setStateModalExamenes] = useState(false);
  const [stateModalPruebas, setStateModalPruebas] = useState(false);
  const [stateModalLista, setStateModalLista] = useState(false);
  const [stateModalPruebasApr, setStateModalPruebasApr] = useState(false);
  const [stateModalPublicacion, setStateModalPublicacion] = useState(false);
  const [stateModalRevision, setStateModalRevision] = useState(false);
  const [stateModalRevisionOp, setStateModalRevisionOp] = useState(false);
  const [updState, setUpdState] = useState(undefined);
  const [userId, setUserId] = useState(true);
  const { id } = useParams();
  const { user, isAuthenticated, isLoading } = useAuth0();

  const listaAux = [
    { id: "auxilioAlimentacion", name: "Auxilio de Alimentación" },
    { id: "auxilioLocalizacion", name: "Auxilio de Localización" },
    { id: "auxilioMovilizacion", name: "Auxilio de Movilización" },
    { id: "bonificacionCIS", name: "Bonificación C.I.S." },
    { id: "bonificacionSIS", name: "Bonificación S.I.S." },
    { id: "primaElSauceMansovar", name: "Prima El Sauce Mansovar" },
    { id: "primaHabitacionalCIS", name: "Prima Habitacional C.I.S." },
    {
      id: "primaAlimentacionYAlojamientoMasaro",
      name: "Prima Alimentacion y Alojamiento Mansaro",
    },
    { id: "auxilioGaitanSIS", name: "Auxilio Económico Gaitán S.I.S. Mensual" },
    {
      id: "auxilioConvencionalECP",
      name: "Auxilio Transporte Convecional ECP",
    },
    {
      id: "subsidioConvencionalHabitacion",
      name: "Subsidio Convencional Habitación",
    },
    { id: "auxilioTransporteConv", name: "Auxilio Transporte Conv." },
    {
      id: "bonificacionBeneficioBienestar",
      name: "Bonificación Beneficio de Bienestar",
    },
    { id: "auxCaminanteNoSalarial", name: "AUXILIO DE CAMINANTE NO SALARIAL" },
    { id: "auxNoSalarialCasino", name: "AUXILIO NO SALARIAL CASINO" },
    {
      id: "auxProduccionYCampoSIS",
      name: "AUXILIO DE PRODUCCION Y DE CAMPO S.I.S",
    },
    { id: "auxAlimentacionDiario", name: "AUXILIO ALIMENTACION DIARIO S.I.S" },
    { id: "auxMovilizacionDiario", name: "AUXILIO MOVILIZACION DIARIO S.I.S" },
    { id: "auxLocalizacionDiario", name: "AUXILIO LOCALIZACION DIARIO S.I.S" },
    { id: "auxLoncheSIS", name: "AUXILIO POR LONCHE S.I.S" },
    {
      id: "auxEspecialTransporteSIS",
      name: "AUXILIO ESPECIAL DE TRANSPORTE SIS",
    },
    {
      id: "auxEspecialAlimentacionSIS",
      name: "AUXILIO ESPECIAL DE ALIMENTACION SIS",
    },
    { id: "auxEspecialLejanias", name: "AUXILIO ESPECIAL DE LEJANIAS" },
    {
      id: "auxNoSalarialBloqueMatambo",
      name: "AUXILIO NO SALARIAL BLOQUE MATAMBO",
    },
    {
      id: "auxNoSalarialBloqueCampoRico",
      name: "AUXILIO NO SALARIAL BLOQUE CAMPO RICO",
    },
    { id: "auxViaticosTSA", name: "AUXILIO POR VIATICOS TSA" },
    {
      id: "auxTrabajoRemotoUtipecSIS",
      name: "AUXILIO TRABAJO REMOTO UTIPEC SIS",
    },
    {
      id: "auxNoSalarialBloqueMaranta",
      name: "AUXILIO NO SALARIAL BLOQUE MARANTA",
    },
    {
      id: "auxAlimentacionDiarioCIS",
      name: "AUXILIO ALIMENTACION DIARIO C.I.S",
    },
    { id: "auxViaticosEMO", name: "AUXILIO POR VIATICOS EMO" },
    {
      id: "auxEconomicoObrasMetalMecanica",
      name: "AUXILIO ECONOMICO OBRAS METALMECANICA",
    },
    { id: "auxTransporteDiarioSIS", name: "AUXILIO DE TRANSPORTE DIARIO SIS" },
  ];

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      setUserId(user["http://localhost:3000/username"]);
    }
    async function getData() {
      await getInformacionAdjuntos(id);
      await getInformacionSolicitud();
    }
    getData();
    getCandidatos();
    document.title = "Detalle APE";
  }, []);

  useEffect(() => {
    getPasosProceso();
    getPasoActivo();
  }, [data]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      const dataCandidato = candidatos.filter(
        (candidato) => candidato.candidatoId == data.candidatoActivo
      );
      setDataCandidatoActivo(dataCandidato[0]);
    }
  }, [candidatos, data]);

  const cancelarSolicitud = () => {
    let newData = { ...data };
    newData.estadoAPE = "CANCELADA";
    setData(newData);
    navigate("/home/proceso-seleccion");
  };

  const resetModals = () => {
    setStateModalAdjunto(false);
    setStateModalCancelacion(false);
    setStateModalEntrevista(false);
    setStateModalEstudio(false);
    setStateModalPruebas(false);
    setStateModalLista(false);
    setStateModalPruebasApr(false);
    setStateModalRevision(false);
    setModalTransaction(false);
  };

  const downloadFile = async (filename) => {
    try {
      let downloadLink = await getDownloadURLAPI(`APEFiles/${id}`, filename);
      let downloadWindow = window.open(
        downloadLink,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const downloadSolicitud = async () => {
    setModalTransaction(true);
    let body = {
      solicitudId: id,
    };
    try {
      let downloadLink = await exportarAPE(body);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      setModalTransaction(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const downloadZip = async () => {
    setModalTransaction(true);
    try {
      let downloadLink = await getFinalFileZip(`APEFiles/${id}`, userData);
      setModalTransaction(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const getActiveStepAge = (updateDate) => {
    const now = new Date(Date.now());
    const age =
      (now.getTime() - new Date(updateDate).getTime()) / (24 * 60 * 60 * 1000);
    return age ?? 0;
  };

  const getInformacionAdjuntos = async (id) => {
    let filesList = await getFileList(`APEFiles/${id}/`);
    setFileList(filesList);
  };

  const getCandidatos = async () => {
    setLoading(true);
    const req = await listadoCandidatos({ codigoAPE: id });
    setCandidatos([...req.data.data]);
    setLoading(false);
  };

  const getInformacionSolicitud = async () => {
    let body = {
      solicitudId: id,
      cod_empr: userData.codigoEmpresa,
    };
    const APEInfo = await getAPE(body);
    if (APEInfo.data.status !== "CONSULTA_EXITOSA") {
      toastError("Hubo un problema con la solicitud");
      navigate("/home/proceso-seleccion");
    }
    const tempData = APEInfo.data.data;
    tempData["salario"] = parseInt(APEInfo.data.data.salario).toLocaleString();
    setData(tempData);
    setLoading(false);
  };

  const updateDataApeLocal = (newData) => {
    const tempObj = data;
    Object.keys(newData).forEach((key) => {
      tempObj[key] = newData[key];
    });
    setData({ ...tempObj });
  };

  const renderConfirmacionMatrizI = () => {
    try {
      Swal.fire({
        title: "¿Desea aceptar la Aprobación de Empleo?",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        html:
          "El proceso pasará a la etapa de reclutamiento con los archivos adjuntos existentes actualmente." +
          "<p>En caso de regresar el proceso escriba aca las razones:</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "No, regresar",
        cancelButtonText: "Sí, confirmar!",
      }).then(async (result) => {
        if (result.isDismissed) {
          let body = {
            cod_soli: id,
            cod_empr: userData.codigoEmpresa,
            data: {
              cmp_stat: "PUBLICACION",
            },
          };
          await editarAPE(body);
        } else if (result.isConfirmed) {
          await handleDevolver(result.value);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getPasoActivo = () => {
    let pasoActivo = 0;
    Object.keys(glosarioProceso1).forEach((key, index) => {
      if (glosarioProceso1[key].id === data.estadoAPE) {
        pasoActivo = { index, ...glosarioProceso1[key] };
      }
    });
    setPasoActivo(pasoActivo);
    return pasoActivo;
  };

  const getPasosProceso = () => {
    let pasosTemp = [];
    Object.keys(glosarioProceso1).forEach((key) => {
      pasosTemp.push(glosarioProceso1[key].name);
    });
    setPasos(pasosTemp);
  };

  const agregarCandidato = (e) => {
    const tempArr = candidatos;
    tempArr.push(e);
    setCandidatos([...tempArr]);
  };
  const eliminarCandidato = (e) => {
    const tempArr = candidatos;
    const tempCandidato = tempArr.filter((cand) => cand.cedula == e.cedula);
    const candidatoIndex = tempArr.indexOf(tempCandidato[0]);
    tempArr.splice(candidatoIndex, 1);
    setCandidatos([...tempArr]);
  };

  const handleCancelar = async () => {
    setModalTransaction(true);
    toggleModalCancelacion();
    setModalTransaction(false);
  };

  const handleDelete = async (file) => {
    setModalTransaction(true);
    let tempFileList = fileList;
    let fileIndex;
    try {
      setLoading(true);
      fileIndex = fileList.indexOf(file);
      tempFileList.splice(fileIndex, 1);
      await deleteFile(`APEFiles/${id}`, file.fileName);
      setFileList(tempFileList);
      setLoading(false);
      toastSuccess("Archivo Eliminado!");
    } catch (error) {
      toastError("Ocurrio un error al eliminar el archivo");
    }
    setModalTransaction(false);
  };

  const handleDevolver = async (msg) => {
    setModalTransaction(true);
    let body = {
      cod_soli: id,
      cod_empr: userData.codigoEmpresa,
      data: {
        cmp_stat: "APROBACION1",
        cod_actu: data.flujo.cedulaPrimerAprobador,
      },
    };
    const correoData = {
      codigoAPE: id,
      enviarA: [
        data.flujo.emailPrimerAprobador,
        "profesional.reclutamiento@confipetrol.com",
      ],
      comentarios: msg,
    };
    await editarAPE(body);
    await envioCorreoDevolucion(correoData);
    navigate("/home/proceso-seleccion");
    setModalTransaction(false);
  };

  const FileUploader = () => {
    return (
      <div className={"FileUploader-style"}>
        <IconButton
          aria-label="Add"
          onClick={() => {
            setEditAttachments(!editAttachments);
          }}
        >
          <MdEdit size={24} />
        </IconButton>
      </div>
    );
  };

  const updateStateInDb = async (dataUpd) => {
    setLoading(true);
    let listadoAnillos = [
      "ANILLO_AREA_INFLUENCIA",
      "ANILLO_MUNICIPIO_ALEDANO",
      "ANILLO_DEPARTAMENTAL",
      "ANILLO_NACIONAL",
    ];
    let anillo = listadoAnillos.includes(updState)
      ? updState
      : data.anilloReclutamiento;
    let tempData = { ...data };
    tempData.estadoAPE = dataUpd.cmp_stat ?? updState;
    tempData.observacionesReclutamiento = dataUpd.observacion;
    tempData.calificacionHabilidades =
      dataUpd.grd_habb ?? data.calificacionHabilidades ?? 0;
    tempData.calificacionHSEQ = dataUpd.grd_hseq ?? data.calificacionHSEQ ?? 0;
    tempData.calificacionPruebaTecnica =
      dataUpd.grd_tecn ?? data.calificacionPruebaTecnica ?? 0;
    tempData.calificacionEntrevista =
      dataUpd.grd_entr ?? data.calificacionEntrevista ?? 0;
    tempData.anilloReclutamiento = anillo;
    tempData.anilloReclutamiento = anillo;
    try {
      await updateState({
        observacion: dataUpd.observacion,
        grd_habb: dataUpd.grd_habb,
        grd_hseq: dataUpd.grd_hseq,
        grd_tecn: dataUpd.grd_tecn,
        grd_entr: dataUpd.grd_entr,
        cmp_stat: dataUpd.cmp_stat ?? updState,
        anl_vaca: anillo,
      });
      if (tempData.estadoAPE !== "PUBLICACION")
        await updateCandidate({
          cedulaCandidato: data.candidatoActivo,
          codigoAPE: id,
          data: {
            estado: tempData.estadoAPE,
          },
        });
      setData(tempData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updateCandidate = async (data) => {
    setLoading(true);
    try {
      await editarCandidato(data);
      await getCandidatos();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updateState = async (dataUpd) => {
    let body = {
      cod_soli: id,
      cod_empr: userData.codigoEmpresa,
      data: {
        cod_actu:
          updState !== "CONTRATACION" ? userId : data.flujo.cedulaContratador,
        grd_habb: dataUpd.grd_habb ?? data.calificacionHabilidades ?? 0,
        grd_hseq: dataUpd.grd_hseq ?? data.calificacionHSEQ ?? 0,
        grd_tecn: dataUpd.grd_tecn ?? data.calificacionPruebaTecnica ?? 0,
        grd_entr: dataUpd.grd_entr ?? data.calificacionEntrevista ?? 0,
        anl_vaca: dataUpd.anl_vaca ?? data.anilloReclutamiento ?? 0,
        obs_recl: dataUpd.observacion ?? data.observacionesReclutamiento,
        cmp_stat: dataUpd.cmp_stat,
      },
    };
    await editarAPE(body);
  };

  const StateUpdateButton = () => {
    const handleClick = () =>
      setSelectState((prevSelectState) => !prevSelectState);
    const handleClose = () => setSelectState(false);
    const handleOpen = () => setSelectState(true);
    const handleChange = async (newState) => {
      setUpdState(newState);
      if (newState === "REVISION") toggleModalRevision();
      else if (newState === "PRUEBAS") toggleModalPruebas();
      else if (newState === "PUBLICACION") toggleModalPublicacion();
      else if (newState === "EXAMEN_MEDICO") toggleModalExamenes();
      else if (newState === "REVISION_OPERACIONES") toggleModalRevisionOp();
      else if (newState === "ENTREVISTA") toggleModalEntrevista();
      else if (newState === "PROCESO_APROBADO") toggleModalPruebasApr();
      else if (newState === "LISTA_CHEQUEO") toggleModalLista();
      else if (newState === "ESTUDIO_SEGURIDAD") toggleModalEstudio();
      else if (newState === "VALIDACION_RECLUTADOR")
        renderConfirmacionMatrizI();
      else toggleModalAdjunto();
    };

    return (
      <div className={"FileUploader-style"}>
        {selectState ? (
          <FormControl>
            <Select
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              open={selectState}
              onClose={handleClose}
              onOpen={handleOpen}
              onChange={(e) => handleChange(e.target.value)}
            >
              {Object.keys(glosarioProceso1).map((key, index) => {
                if (glosarioProceso1[key].id !== "RECLUTADOR")
                  return (
                    <MenuItem
                      key={`state_item_${index}`}
                      value={glosarioProceso1[key].id}
                    >
                      {glosarioProceso1[key].name}
                    </MenuItem>
                  );
              })}
            </Select>
          </FormControl>
        ) : null}
        <IconButton
          aria-label="Add"
          onClick={() => {
            handleClick();
          }}
        >
          <MdEdit size={24} />
        </IconButton>
      </div>
    );
  };

  const renderBadgeAdjuntos = () => {
    return fileList.map((file, index) => {
      if (editAttachments) {
        return (
          <Button
            key={`attachment_button_edit_${index}`}
            className="badge-attached-file"
            outline
            onClick={() => {
              handleDelete(file);
            }}
            color="danger"
          >
            {file.fileName}
            <RiDeleteBin6Line size={16} />
          </Button>
        );
      } else {
        return (
          <Button
            key={`attachment_button_${index}`}
            className="badge-attached-file"
            outline
            onClick={() => {
              downloadFile(file.fileName);
            }}
            color="primary"
          >
            {file.fileName}
            <BsPaperclip size={16} />
          </Button>
        );
      }
    });
  };

  const toggleModalAdjunto = () =>
    setStateModalAdjunto((prevStateModalAdjutno) => !prevStateModalAdjutno);
  const toggleModalCancelacion = () =>
    setStateModalCancelacion(
      (prevStateModalCancelacion) => !prevStateModalCancelacion
    );
  const toggleModalSuspender = () =>
    setStateModalSuspender(
      (prevStateModalSuspender) => !prevStateModalSuspender
    );
  const toggleModalRevision = () =>
    setStateModalRevision((prevStateModalRevision) => !prevStateModalRevision);
  const toggleModalRevisionOp = () =>
    setStateModalRevisionOp(
      (prevStateModalRevisionOp) => !prevStateModalRevisionOp
    );
  const toggleModalPruebas = () =>
    setStateModalPruebas((prevStateModalPruebas) => !prevStateModalPruebas);
  const toggleModalPublicacion = () =>
    setStateModalPublicacion(
      (prevStateModalPublicacion) => !prevStateModalPublicacion
    );
  const toggleModalEntrevista = () =>
    setStateModalEntrevista(
      (prevStateModalEntrevista) => !prevStateModalEntrevista
    );
  const toggleModalExamenes = () =>
    setStateModalExamenes((prevStateModalExamenes) => !prevStateModalExamenes);
  const toggleModalPruebasApr = () =>
    setStateModalPruebasApr(
      (prevStateModalPruebasApr) => !prevStateModalPruebasApr
    );
  const toggleModalLista = () =>
    setStateModalLista((prevStateModalLista) => !prevStateModalLista);
  const toggleModalEstudio = () =>
    setStateModalEstudio((prevStateModalEstudio) => !prevStateModalEstudio);

  if (loading) {
    return (
      <div className={"loading-area"}>
        {" "}
        <Loading />{" "}
      </div>
    );
  } else {
    return (
      <div className="visualizador-ape">
        <LoadingModalTransparent isOpen={modalTransaction} />
        <Toaster />
        <ModalExamenes
          toastSuccess={(e) => {
            toastSuccess(e);
          }}
          toastError={(e) => {
            toastSuccess(e);
          }}
          toggle={toggleModalExamenes}
          modal={stateModalExamenes}
          setLoading={setLoading}
          setData={(e) => {
            setData(e);
          }}
          fileList={fileList}
          setFileList={setFileList}
          editarAPE={(e) => {
            editarAPE(e);
          }}
          data={data}
          id={id}
          updateAPE={(e) => {
            updateDataApeLocal(e);
          }}
        />
        <ModalSuspenderAPE
          toastSuccess={(e) => {
            toastSuccess(e);
          }}
          toastError={(e) => {
            toastSuccess(e);
          }}
          toggle={toggleModalSuspender}
          modal={stateModalSuspender}
          data={data}
          id={id}
        />
        <ModalRevisionOperaciones
          toastSuccess={(e) => {
            toastSuccess(e);
          }}
          toastError={(e) => {
            toastSuccess(e);
          }}
          toggle={toggleModalRevisionOp}
          modal={stateModalRevisionOp}
          setData={(e) => {
            setData(e);
          }}
          setFileList={setFileList}
          data={data}
          updateAPE={(e) => {
            updateDataApeLocal(e);
          }}
          id={id}
        />
        <ModalPublicacion
          toastSuccess={(e) => {
            toastSuccess(e);
          }}
          toastError={(e) => {
            toastSuccess(e);
          }}
          toggle={toggleModalPublicacion}
          setLoading={(e) => setLoading(e)}
          modal={stateModalPublicacion}
          setFileList={setFileList}
          setData={(e) => {
            setData(e);
          }}
          fileList={fileList}
          data={data}
          id={id}
          updateAPE={(e) => {
            updateDataApeLocal(e);
          }}
        />
        <ModalCancelacion
          toastSuccess={(e) => {
            toastSuccess(e);
          }}
          toastError={(e) => {
            toastSuccess(e);
          }}
          toggle={toggleModalCancelacion}
          modal={stateModalCancelacion}
          action={cancelarSolicitud}
          data={data}
        />
        {updState !== undefined ? (
          <ModalAdjunto
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={toggleModalAdjunto}
            modal={stateModalAdjunto}
            setLoading={setLoading}
            setFileList={setFileList}
            fileList={fileList}
            newState={updState}
            dataApe={data}
            observacion={data.observacionesReclutamiento}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalPruebasTecnicas
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={resetModals}
            modal={stateModalPruebas}
            setLoading={setLoading}
            setFileList={setFileList}
            fileList={fileList}
            newState={updState}
            observacion={data.observacionesReclutamiento}
            dataApe={data}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalEntrevista
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={toggleModalEntrevista}
            modal={stateModalEntrevista}
            setLoading={setLoading}
            setFileList={setFileList}
            fileList={fileList}
            newState={updState}
            observacion={data.observacionesReclutamiento}
            dataApe={data}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalRevision
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={toggleModalRevision}
            modal={stateModalRevision}
            setLoading={(e) => setLoading(e)}
            setFileList={(e) => setFileList(e)}
            fileList={fileList}
            data={updState}
            dataApe={data}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalProcesoAprobado
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={toggleModalPruebasApr}
            modal={stateModalPruebasApr}
            setLoading={(e) => setLoading(e)}
            setFileList={(e) => setFileList(e)}
            fileList={fileList}
            data={updState}
            dataAPE={data}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalListaChequeo
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={toggleModalLista}
            modal={stateModalLista}
            setLoading={(e) => setLoading(e)}
            setFileList={(e) => setFileList(e)}
            fileList={fileList}
            data={updState}
            dataAPE={data}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        {updState !== undefined ? (
          <ModalEstudioSeguridad
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastSuccess(e);
            }}
            toggle={toggleModalEstudio}
            modal={stateModalEstudio}
            setLoading={setLoading}
            setFileList={setFileList}
            fileList={fileList}
            newState={updState}
            observacion={data.observacionesReclutamiento}
            dataApe={data}
            id={id}
            updateAPE={(e) => {
              updateDataApeLocal(e);
            }}
          />
        ) : null}
        <Breadcrumb>
          <BreadcrumbItem active>
            <Link to={"/home/proceso-seleccion"}>Solicitudes</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Solicitud N° {id}</BreadcrumbItem>
        </Breadcrumb>
        <div className="breadcum-display-content-2">
          <OnHoldAPEButton
            suspendida={data.suspendida}
            onClick={() => {
              toggleModalSuspender();
            }}
          />
          <DescargarAPEButton
            onClick={() => {
              downloadSolicitud();
            }}
          />
          <DescargarZIPButton
            onClick={() => {
              downloadZip();
            }}
          />
        </div>
        <div>
          <InfoCard
            button={!data.suspendida ? <StateUpdateButton /> : null}
            title={"Estado Proceso"}
          >
            <HorizontalLabelPositionBelowStepper
              activeStepAge={getActiveStepAge(data.fec_actu)}
              steps={pasos}
              activeStep={pasoActivo.index}
              pasoActivo={pasoActivo}
            />
          </InfoCard>
        </div>
        <br />
        <InfoCard title={"1. Tipo de Vacante"}>
          <Row>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Vacante</Label>
              <Input
                type="text"
                name="text"
                id="inputVacante"
                readOnly
                defaultValue={data.tipoVacante}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Cargo</Label>
              <Input
                type="text"
                name="text"
                id="inputCargo"
                readOnly
                defaultValue={data.codigoCargo}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Cantidad de Vacantes</Label>
              <Input
                type="text"
                name="text"
                id="inputProceso"
                readOnly
                defaultValue={data.numeroPlazas}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Proceso/Area</Label>
              <Input
                type="text"
                name="text"
                id="inputProceso"
                readOnly
                defaultValue={data.proceso}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Trabajador a Reemplazar</Label>
              <Input
                type="text"
                name="text"
                id="inputTrabajadorReemp"
                readOnly
                defaultValue={data.trabajadorReemplazar}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"2. Origen del Cargo"}>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Contractual/No Contractual</Label>
              <Input
                type="text"
                name="text"
                id="inputContractual"
                readOnly
                defaultValue={data.tipoContractual}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Cliente Comercial</Label>
              <Input
                type="text"
                name="text"
                id="inputClienteCom"
                readOnly
                defaultValue={data.clienteComercial}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">N° de Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputNumContrato"
                readOnly
                defaultValue={data.numeroContrato}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Ítem de Cobro</Label>
              <Input
                type="text"
                name="text"
                id="inputItemCobro"
                readOnly
                defaultValue={data.itemCobro}
              />{" "}
              {/* confirmar */}
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Código ATA</Label>
              <Input
                type="text"
                name="text"
                id="inputCodigoATA"
                readOnly
                defaultValue={data.codigoATA}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Centro de Costos</Label>
              <Input
                type="text"
                name="text"
                id="inputCentroCostos"
                readOnly
                defaultValue={data.centroCosto}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">*PEP</Label>
              <Input
                type="text"
                name="text"
                id="inputPep"
                readOnly
                defaultValue={data.PEP}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"3. Condiciones Laborales"}>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Campo</Label>
              <Input
                type="text"
                name="text"
                id="inputCampo"
                readOnly
                defaultValue={data.campo}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Especialidad</Label>
              <Input
                type="text"
                name="text"
                id="inputEspecialidad"
                readOnly
                defaultValue={data.especialidad}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Duración del Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputDuracionContrato"
                readOnly
                defaultValue={data.duracionContrato}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Contrato</Label>
              <Input
                type="text"
                name="text"
                id="inputTipoContrato"
                readOnly
                defaultValue={data.tipoContrato}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Nómina/Planilla</Label>
              <Input
                type="text"
                name="text"
                id="inputNomina"
                readOnly
                defaultValue={data.tipoNomina}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Tipo de Salario</Label>
              <Input
                type="text"
                name="text"
                id="inputTipoSalario"
                readOnly
                defaultValue={data.tipoSalario}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Salario Básico</Label>
              <Input
                type="text"
                name="text"
                id="inputSalario"
                readOnly
                defaultValue={data.salario}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Jefe Inmediato</Label>
              <Input
                type="text"
                name="text"
                id="inputJefe"
                readOnly
                defaultValue={data.jefeInmediato}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Funciones de Conductor</Label>
              <Input
                type="text"
                name="text"
                id="inputFuncionesConductor"
                readOnly
                defaultValue={data.funcionesConductor}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Turno/Régimen de Trabajo</Label>
              <Input
                type="text"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.turno}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Auxilio de Alimentación</Label>
              <Input
                type="text"
                name="text"
                id="inputAuxAlim"
                readOnly
                defaultValue={data.auxilioAlimentacion}
              />
            </Col>
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Auxilio de Localización</Label>
              <Input
                type="text"
                name="text"
                id="inputLoc"
                readOnly
                defaultValue={data.auxilioLocalizacion}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col lg="3" md="6" xs="12">
              <Label for="exampleSelect">Auxilio de Movilización</Label>
              <Input
                type="text"
                name="text"
                id="inputAuxMov"
                readOnly
                defaultValue={data.auxilioMovilidad}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Otros</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.otros}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Observaciones APE</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.observaciones}
              />
            </Col>
          </Row>
          <Row xs="2">
            <Col xs="12">
              <Label for="exampleSelect">Observaciones Reclutamiento</Label>
              <Input
                type="textarea"
                name="text"
                id="inputTurno"
                readOnly
                defaultValue={data.observacionesReclutamiento ?? ""}
              />
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"3.1 Auxilios"}>
          <Row xs="2">
            {listaAux.map((aux) => {
              if (data[aux.id] !== undefined && data[aux.id] !== null) {
                return (
                  <Col lg="3" md="6" xs="12">
                    <Label for="exampleSelect">{aux.name}</Label>
                    <Input
                      type="text"
                      name="text"
                      id="inputSalario"
                      readOnly
                      defaultValue={data[aux.id] ? data[aux.id] : "$ 0"}
                    />
                  </Col>
                );
              }
            })}
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"4. Calificación Pruebas y Entrevista"}>
          <Row xs="2">
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Prueba HSEQ</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaHSEQ"
                readOnly
                defaultValue={data.calificacionHSEQ ?? 0}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Prueba Técnica</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaTecnica"
                readOnly
                defaultValue={data.calificacionPruebaTecnica ?? 0}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Prueba Habilidades Blandas</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaHB"
                readOnly
                defaultValue={data.calificacionHabilidades ?? 0}
              />
            </Col>
            <Col lg="2" md="6" xs="12">
              <Label for="exampleSelect">Entrevista</Label>
              <Input
                type="text"
                name="text"
                id="inputPruebaEntrevista"
                readOnly
                defaultValue={data.calificacionEntrevista ?? 0}
              />{" "}
              {/* confirmar */}
            </Col>
            <Col lg="4" md="6" xs="12">
              <Label for="exampleSelect">Resultado</Label>
              <Input
                type="text"
                name="text"
                id="inputResultados"
                readOnly
                defaultValue={data.calificacionPromedio ?? 0}
              />{" "}
              {/* confirmar */}
            </Col>
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"5. Recursos"}>
          <Row xs="12">
            {data.recursos !== null &&
            data.recursos !== undefined &&
            data.recursos.length > 0 ? (
              data.recursos.map((recurso, index) => {
                return (
                  <Button
                    className="badge-attached-file"
                    key={`key_recurso_btn_${index}`}
                    outline
                    disabled
                    color="success"
                  >
                    {recurso}
                    <BsCheck size={16} />
                  </Button>
                );
              })
            ) : (
              <div className="ape-list-nodata-text">
                <p>No hay recursos asignados</p>
              </div>
            )}
          </Row>
        </InfoCard>
        <br />
        <InfoCard title={"Archivos Adjuntos"} button={<FileUploader />}>
          <Row xs="2">{renderBadgeAdjuntos()}</Row>
        </InfoCard>
        <br />
        <div className={"breadcum-header-buttons"}>
          <div className={"button-bar-container"}>
            <div className={"button-bar-button"}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleCancelar()}
                disabled={false}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default withAuthenticationRequired(
  connect(mapStateToProps)(VisualizadorAPEReclutamiento),
  {
    onRedirecting: () => <Loading />,
  }
);
